import { useState, useEffect } from 'react'
import { useTranslation } from '../../i18n/LanguageContext'
import './DownloadNotification.css'

const DownloadNotification = () => {
  const { t } = useTranslation()
  const [notification, setNotification] = useState(null)

  useEffect(() => {
    const handleError = (e) => {
      window.__downloadErrorHandled = true
      setNotification({
        type: 'error',
        message: e.detail.message
      })
      
      // Auto-hide after 6 seconds
      setTimeout(() => {
        setNotification(null)
      }, 6000)
    }

    const handleSuccess = (e) => {
      window.__downloadSuccessHandled = true
      setNotification({
        type: 'success',
        message: e.detail.message
      })
      
      // Auto-hide after 4 seconds
      setTimeout(() => {
        setNotification(null)
      }, 4000)
    }

    window.addEventListener('show-download-error', handleError)
    window.addEventListener('show-download-success', handleSuccess)

    return () => {
      window.removeEventListener('show-download-error', handleError)
      window.removeEventListener('show-download-success', handleSuccess)
    }
  }, [])

  if (!notification) return null

  return (
    <div className={`download-notification download-notification--${notification.type}`}>
      <div className="download-notification__content">
        <div className="download-notification__icon">
          {notification.type === 'error' ? (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
              <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
              <path d="M8 12l3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
          )}
        </div>
        <div className="download-notification__message">{notification.message}</div>
        <button 
          className="download-notification__close"
          onClick={() => setNotification(null)}
          aria-label={t('account.cancel')}
        >
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
      <div className="download-notification__progress" />
    </div>
  )
}

export default DownloadNotification
